<template>
  <div class="play-container">
    <top-bar :user="this.user" />

    <div class="container-right">
      <Menu :user="this.user" :menuSelected="{ dashboard: true }" />
      <!-- <div class="data-content"> -->
        <div :class="{
          content: true,
          'dashboard-beneficiary': true,
        }">
          <h1>{{ $t("cmsLang.overviewTitle") }}</h1>
          <div v-for="(info, name) in statistics" :key="name" class="d-inline-block position-relative">
            <div class="offer-wrapper">
              <p class="small">
                {{ $t('cmsLang.statistic_' + name) }}
              </p>
              <p class="stats">
                {{ info }}
              </p>
            </div>
          </div>
          <br />
          <br />
          <h1>{{ $t("cmsLang.recentTitle") }}</h1>
          <br />
          <div class="row d-flex flex-column align-items-baseline w-80">
            <div class="radioButtonCustom">
              <label v-for="(tab, index) in selectTabs" :key="index">
                <input name="categorytype" type="radio" :value="tab" v-model="selectedTab"
                  @change="selectTab($event.target, tab)" :checked="tab === selectedTab">
                {{ $t("cmsLang.logLabel_" + tab) }}</label>
            </div>
          </div>
          <div class="row border-round-white">
            <div v-if="logInfos == null">
          <img class="w-80" src="@/assets/images/cms-mkt/loading.gif" />
        </div>
            <div class="logInfoDiv d-flex flex-column align-items-start ">
              <div v-for="(info, index) in logInfos" :key="index">
                <p :key="index" class="logInfo opacity-50">
                  {{ info.date }}
                </p>
                <p class="logInfo">{{ info.details }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->
    <ResetPassword v-if="this.isUserNew(this.user)" :user="this.user" />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "@/components/cms-mkt/TopBar.vue";
import Menu from "@/components/cms-mkt/Menu.vue";
import ResetPassword from "@/components/fragments/cms-mkt/ResetPasswordPopup.vue";
import httpServiceCustomer from "@/http/http-play.js";


export default {
  name: "Dashboard",
  components: { TopBar, Menu, ResetPassword },
  data() {
    return {
      user: null,
      statistics: null,
      logInfos: null,
      selectedTab: "all",
      selectTabs: ["all", "submissions", "approvals", "interactions", "account"],
      isLoading: false,
    };
  },
  methods: {
    logout() {
      Cookies.remove("userLink");
      Cookies.remove("token");
      this.$router.push({
        name: "login",
        params: { loginUserSelected: false },
      });
    },
    selectTab(element, entry) {
      this.selectedTab = entry;
      this.getLogs();
    },
    getLogs() {
      this.logInfos = null
      // @queryParam name = search by name
      var logParams = "?";
      if (this.selectedTab != "all") {
        logParams += "tab=" + this.selectedTab;
      }
      this.isLoading = true;
      logParams +=
        "&per_page=1000" +
        "&page=1";

      httpServiceCustomer.customerService
        .getLogs(logParams, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          return error.response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.logInfos = response.data;
          }
          this.isLoading = false;

        });
    },
    getStatistics() {
      this.statistics = [];
      // @queryParam name = search by name

      httpServiceCustomer.customerService
        .getStatistics(Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          return error.response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.statistics = response.data;

            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          }
        });
    },
  },
  mounted() {
    this.getStatistics();
    this.getLogs();

  },
  created() {
    this.user = this.getUser();
  },
};
</script>
<style type="text/css" scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>

.stats {
  font-family: 'Krona One';
  font-size: 64px;
  font-weight: 400;
  line-height: 80px;
  letter-spacing: 0em;
  text-align: left;

}

.logInfo {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
}

.opacity-50 {
  opacity: 50%;
}

.logInfoDiv {
  margin: 20px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: clip;
  width: 100%;
}

.row {
  /* max-height: 450px; */
  width: 98%;
}

.small {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #504f4f !important;
}

.offer-wrapper:hover {
  box-shadow: 0 0 0;
}
</style>

